import { scrollTo, scrollTop } from './services/utils'

export default class ButtonFollow {
  constructor() {
    const buttons = document.querySelectorAll('[data-scroll-to]')

    buttons.forEach((e) => {
      e.addEventListener('click', () => {
        const to = e.dataset.scrollTo
        if (to === 'top') scrollTop()
        else scrollTo(document.querySelector(to))
      })
    })
  }
}
